// Indonesian translations
export default {
  common: {
    loading: 'Memuat...',
    error: 'Error',
    success: 'Berhasil',
    cancel: 'Batal',
    save: 'Simpan',
    delete: 'Hapus',
    edit: 'Edit',
    view: 'Lihat',
    close: 'Tutup',
    back: 'Kembali',
    next: 'Selanjutnya',
    previous: 'Sebelumnya',
    search: 'Cari',
    filter: 'Filter',
    all: 'Semua',
    yes: 'Ya',
    no: 'Tidak',
    confirm: 'Konfirmasi',
    login: 'Masuk',
    logout: 'Log Out',
    expand: 'Buka',
    collapse: 'Tutup'
  },
  header: {
    home: 'Beranda',
    maps: 'Peta',
    products: 'Produk',
    services: 'Services',
    about: 'Tentang Spectra',
    login: 'Log In'
  },
  home: {
    title: 'SPECTRA',
    subtitle: 'Satellite Platform for Emergency Crisis, Tracking and Remote Analytic',
    description: 'Platform berbasis satelit untuk manajemen bencana dan analisis geospasial',
    heroHeading: 'Near-Realtime. Open. Unlimited Insights',
    heroDescription: 'SPECTRA adalah Platform Satelit untuk Emergency Crisis Tracking dan Remote Analytics. Akses citra satelit berkualitas tinggi, terbarui secara berkala, dan near-realtime untuk monitoring bencana, penelitian, rapid response, dan pengambilan keputusan berbasis data.',
    searchTitle: 'Mulai jelajahi data citra',
    searchRegion: 'Nama Daerah',
    searchRegionPlaceholder: 'Masukkan nama daerah',
    searchEventType: 'Jenis Kejadian',
    searchButton: 'Cari Data',
    latestReleases: 'Rilisan Terbaru',
    previous: 'Sebelumnya',
    next: 'Selanjutnya',
    viewAll: 'Lihat Semua',
    interactiveMap: 'Peta Interaktif',
    interactiveMapDesc: 'Akses peta interaktif untuk visualisasi data geospasial dan analisis bencana',
    accessMap: 'Akses Peta',
    partners: 'Mitra Kolaborasi',
    allEvents: 'Semua kejadian',
    banjir: 'Banjir',
    longsor: 'Longsor',
    access: 'Akses',
    loadingLatest: 'Memuat produk terbaru...',
    clickToClose: 'Klik di luar gambar untuk menutup',
    pressEscape: 'Tekan ESC untuk menutup'
  },
  maps: {
    title: 'Peta Dinamis',
    subtitle: 'Jelajahi peta interaktif dengan berbagai layer dan basemap',
    selectMap: 'Pilih Peta',
    loading: 'Memuat peta...',
    error: 'Error memuat peta',
    noData: 'Peta tidak ditemukan',
    layers: 'Map Layers',
    showAll: 'Tampilkan Semua',
    hideAll: 'Sembunyikan Semua',
    basemap: 'Basemap',
    zoomToLayer: 'Zoom ke Layer',
    opacity: 'Opacity',
    selectBasemap: 'Pilih Basemap',
    viewMap: 'Lihat Peta',
    zoom: 'Zoom',
    center: 'Titik Tengah',
    noMapsAvailable: 'Tidak ada peta tersedia',
    showInfo: 'Tampilkan Info Peta',
    legend: 'Legenda'
  },
  products: {
    title: 'Produk Spectra',
    breadcrumbHome: 'Beranda',
    breadcrumbProducts: 'Produk',
    searchPlaceholder: 'Masukkan nama daerah',
    searchRegion: 'Nama Daerah',
    searchEventType: 'Jenis Kejadian',
    allEvents: 'Semua kejadian',
    allCategories: 'Semua Kategori',
    noResults: 'Tidak ada produk ditemukan',
    loading: 'Memuat produk...',
    access: 'Akses',
    preview: 'Pratinjau',
    download: 'Unduh',
    date: 'Tanggal',
    region: 'Wilayah',
    category: 'Kategori',
    clickToClose: 'Klik di luar gambar untuk menutup',
    pressEscape: 'Tekan ESC untuk menutup',
    latest: 'Terbaru',
    oldest: 'Terlama',
    releaseDate: 'Tanggal Rilis'
  },
  mapAdmin: {
    title: 'Admin Peta',
    createMap: 'Buat Peta Baru',
    editMap: 'Edit Peta',
    deleteMap: 'Hapus Peta',
    createGroup: 'Buat Group Layer Baru',
    editGroup: 'Edit Group Layer',
    deleteGroup: 'Hapus Group Layer',
    createLayer: 'Buat Layer Baru',
    editLayer: 'Edit Layer',
    deleteLayer: 'Hapus Layer',
    viewMap: 'Lihat Peta',
    name: 'Nama',
    description: 'Deskripsi',
    center: 'Titik Tengah',
    zoom: 'Zoom Level',
    public: 'Publik',
    layerName: 'Nama Layer',
    layerType: 'Tipe Layer',
    url: 'URL',
    zIndex: 'Z-Index',
    visible: 'Terlihat',
    style: 'Style (JSON)',
    geometry: 'Geometry (GeoJSON)',
    save: 'Simpan',
    cancel: 'Batal',
    success: 'Berhasil',
    error: 'Error',
    noMaps: 'Tidak ada peta',
    noGroups: 'Tidak ada group layer',
    noLayers: 'Tidak ada layer',
    mapCreated: 'Peta berhasil dibuat',
    mapUpdated: 'Peta berhasil diperbarui',
    mapDeleted: 'Peta berhasil dihapus',
    groupCreated: 'Group layer berhasil dibuat',
    groupUpdated: 'Group layer berhasil diperbarui',
    groupDeleted: 'Group layer berhasil dihapus',
    layerCreated: 'Layer berhasil dibuat',
    layerUpdated: 'Layer berhasil diperbarui',
    layerDeleted: 'Layer berhasil dihapus',
    failedToLoad: 'Gagal memuat detail peta',
    failedToCreate: 'Gagal membuat peta',
    failedToUpdate: 'Gagal memperbarui peta',
    failedToDelete: 'Gagal menghapus peta',
    layers: 'Layers',
    layerGroups: 'Layer Groups'
  },
  profile: {
    title: 'Tentang SPECTRA',
    subtitle: 'Platform Satelit untuk Manajemen Bencana'
  },
  contact: {
    title: 'Kontak Kami',
    contactInfo: 'Informasi Kontak',
    availableServices: 'Layanan yang Tersedia',
    operatingHours: 'Jam Operasional',
    technicalSupport: 'Dukungan Teknis',
    training: 'Pelatihan & Capacity Building',
    dataAccess: 'Akses Data',
    collaboration: 'Kolaborasi',
    mondayFriday: 'Senin - Jumat',
    saturdaySunday: 'Tutup',
    urgentNote: 'Untuk permintaan darurat, silakan hubungi melalui email dengan subjek "URGENT"'
  },
  services: {
    title: 'Layanan Web Services',
    subtitle: 'Dokumentasi penggunaan layanan WMS, WCS, dan WFS untuk mengakses data geospasial SPECTRA BRIN.',
    wms: 'WMS',
    wcs: 'WCS',
    wfs: 'WFS',
    getCapabilities: 'GetCapabilities',
    getMap: 'GetMap',
    getFeatureInfo: 'GetFeatureInfo',
    describeCoverage: 'DescribeCoverage',
    getCoverage: 'GetCoverage',
    describeFeatureType: 'DescribeFeatureType',
    getFeature: 'GetFeature',
    transaction: 'Transaction',
    helpTitle: 'Butuh Bantuan?',
    helpText: 'Untuk pertanyaan atau dukungan teknis terkait penggunaan layanan web services, silakan hubungi tim SPECTRA BRIN melalui halaman'
  },
  disclaimer: {
    title: 'Disclaimer & Ketentuan Penggunaan Data',
    warning: 'WAJIB BACA: Ketentuan penggunaan data geospasial dan produk peta SPECTRA BRIN',
    lastUpdated: 'Terakhir diperbarui',
    version: 'Versi'
  },
  footer: {
    copyright: `© ${new Date().getFullYear()} SPECTRA BRIN. All rights reserved.`
  },
  mapProducts: {
    title: 'Produk Peta Interaktif',
    subtitle: 'Visualisasi data berbasis ruang angkasa untuk manajemen dan tanggap darurat bencana.',
    modeLabel: 'Mode tampilan peta',
    modeProducts: 'Peta Produk',
    modeProductsDesc: 'Lapisan peta siap pakai untuk pemantauan',
    modeCatalog: 'Katalog Citra',
    modeCatalogDesc: 'Cari dan lihat citra satelit dari STAC'
  },
  stacCatalog: {
    panelTitle: 'Katalog Citra',
    panelHint: 'Menampilkan citra dalam area peta yang terlihat',
    connectionError: 'Gagal terhubung ke server STAC. Periksa koneksi jaringan atau restart npm start.',
    waitingExtent: 'Menunggu area peta...',
    noResultsInExtent: 'Tidak ada citra di area peta ini. Geser atau zoom peta, lalu coba lagi.',
    guideStep2: 'Pilih citra dari daftar',
    guideStep3: 'Lihat langsung di peta',
    dismissGuide: 'Tutup panduan',
    filters: 'Filter',
    filtersHint: 'Opsional — kosongkan untuk melihat semua data',
    closeFilters: 'Tutup filter',
    openFilters: 'Filter',
    collections: 'Koleksi satelit',
    collectionsHint: 'Tidak memilih apa pun = semua koleksi',
    selectAll: 'Semua',
    clearSelection: 'Kosongkan',
    dateRange: 'Rentang tanggal',
    dateHint: 'Biarkan kosong untuk semua tanggal',
    invalidDateRange: 'Tanggal mulai harus sebelum tanggal akhir.',
    from: 'Dari',
    to: 'Sampai',
    search: 'Cari citra',
    searching: 'Mencari...',
    reset: 'Reset',
    results: 'Hasil',
    resultsHint: 'Geser atau zoom peta untuk memperbarui daftar citra',
    showResults: 'Hasil',
    hideResults: 'Sembunyikan hasil',
    noResults: 'Tidak ada citra yang cocok. Coba ubah filter.',
    adjustFilters: 'Ubah filter',
    noPreview: 'Tanpa pratinjau',
    previewThumb: 'Perbesar pratinjau',
    noDate: 'Tidak ada tanggal',
    popupCollection: 'Koleksi',
    popupDate: 'Tanggal',
    showOnMap: 'Tampilkan di peta',
    showingOnMap: 'Ditampilkan di peta',
    viewing: 'Melihat',
    clearView: 'Lepas',
    pickHint: 'Pilih citra di daftar atau klik batas area di peta',
    emptyMapHint: 'Belum ada hasil — gunakan filter lalu cari',
    hideExtents: 'Sembunyikan batas',
    showExtents: 'Tampilkan batas',
    footprintOn: 'Footprint tampil',
    footprintOff: 'Footprint sembunyi',
    showFootprint: 'Tampilkan footprint di peta',
    hideFootprint: 'Sembunyikan footprint di peta',
    loadingTiles: 'Memuat citra...',
    showGis: 'Salin URL untuk GIS',
    hideGis: 'Sembunyikan URL GIS',
    gisHint: 'Untuk QGIS/ArcGIS — tidak diperlukan untuk melihat di sini',
    copyXyz: 'Salin',
    copied: 'Tersalin',
    basemap: {
      mapbox: 'Peta terang',
      googleHybrid: 'Satelit',
      osm: 'OSM'
    }
  }
};

